import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M-7.5,-1.5h0.5v0.5h-0.5zM-8.5,-1h2.5v0.5h-2.5zM5.5,-1h0.5v1h-0.5zM-6.5,-0.5h1.5v0.5h-1.5zM3,-0.5h0.5v0.5h-0.5zM-5.5,0h1.5v0.5h-1.5zM1.5,0h0.5v0.5h-0.5zM4,0h0.5v0.5h-0.5zM-4,0.5h1v0.5h-1zM0.5,0.5h2v0.5h-2zM3.5,0.5h1v0.5h-1zM-3,1h1.5v0.5h-1.5zM-0.5,1h3v0.5h-3zM-3.5,1.5h6.5v0.5h-6.5zM-3,2h6.5v0.5h-6.5zM-2,2.5h4.5v0.5h-4.5zM-1,3h2v0.5h-2z',
    },
    {
      paint: 'canal',
      d: 'M5,-3.5h0.5v0.5h-0.5zM7,-2h1v0.5h-1zM7.5,-1.5h1v0.5h-1zM8,-1h1.5v0.5h-1.5zM8.5,-0.5h1.5v1h-1.5zM5,0.5h0.5v0.5h-0.5zM7.5,0.5h1.5v0.5h-1.5zM7,1h1.5v0.5h-1.5zM6,1.5h1.5v0.5h-1.5zM5.5,2h1.5v0.5h-1.5zM4.5,2.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'waterLight',
      d: 'M4,-3.5h0.5v1h-0.5zM5.5,-2.5h0.5v1h-0.5zM7,-1h1v0.5h-1zM7.5,-0.5h1v0.5h-1zM7,0h1.5v0.5h-1.5zM7,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-6.5,-6h1v0.5h-1zM-6.5,-5.5h2.5v0.5h-2.5zM-6.5,-5h0.5v4h-0.5zM-5,-5h2.5v0.5h-2.5zM-4,-4.5h3v0.5h-3zM-3,-4h2v4.5h-2zM-2.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M3,-7h0.5v0.5h-0.5zM-6.5,-6.5h0.5v0.5h-0.5zM2,-6.5h1.5v0.5h-1.5zM-5.5,-6h0.5v0.5h-0.5zM1,-6h2.5v0.5h-2.5zM-4,-5.5h0.5v0.5h-0.5zM0,-5.5h3.5v0.5h-3.5zM-6,-5h1v0.5h-1zM-2.5,-5h0.5v0.5h-0.5zM-1,-5h4.5v0.5h-4.5zM-1,-4.5h4v0.5h-4zM-3.5,-4h0.5v0.5h-0.5zM-1,-4h3.5v1h-3.5zM-1,-3h3v3h-3zM3,-2.5h0.5v1h-0.5zM-7,-1.5h0.5v0.5h-0.5zM-6,-1h0.5v0.5h-0.5zM3,-1h0.5v0.5h-0.5zM-5,-0.5h0.5v0.5h-0.5zM-4,0h1v0.5h-1zM-1,0h2.5v0.5h-2.5zM5,0h0.5v0.5h-0.5zM-3,0.5h0.5v0.5h-0.5zM-1,0.5h1.5v0.5h-1.5zM-1.5,1h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-5.5,-4.5h0.5v0.5h-0.5zM-5.5,-4h1v3h-1zM-4,-4h0.5v4h-0.5zM-5,-1h0.5v0.5h-0.5zM2.5,0h0.5v0.5h-0.5zM5.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-7,-6.5h0.5v5h-0.5zM3.5,-6.5h0.5v2h-0.5zM-4.5,-4.5h0.5v0.5h-0.5zM3.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['thatch', 0.7],
      ],
      d: 'M-6,-11h0.5v0.5h-0.5zM-3,-11h0.5v0.5h-0.5zM-7,-9.5h0.5v0.5h-0.5zM-3.5,-9h0.5v1.5h-0.5zM3,-9h0.5v0.5h-0.5zM-7.5,-8.5h0.5v0.5h-0.5zM-6.5,-8.5h0.5v0.5h-0.5zM0.5,-8.5h1v0.5h-1zM4.5,-8.5h1.5v0.5h-1.5zM-9.5,-8h2v0.5h-2zM0.5,-8h0.5v0.5h-0.5zM3.5,-8h2v0.5h-2zM-8.5,-7.5h1.5v0.5h-1.5zM2.5,-7.5h2v0.5h-2zM-7.5,-7h1.5v0.5h-1.5zM1,-7h2v0.5h-2zM-6,-6.5h1v0.5h-1zM-4,-6.5h0.5v0.5h-0.5zM0.5,-6.5h1.5v0.5h-1.5zM-5,-6h2v0.5h-2zM-1,-6h2v0.5h-2zM-3.5,-5.5h3.5v0.5h-3.5zM-2,-5h1v0.5h-1zM4,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'thatch',
      d: 'M-4.5,-12h1v0.5h-1zM-2,-12h3v0.5h-3zM-6,-11.5h1v0.5h-1zM0,-11.5h2.5v0.5h-2.5zM-7,-11h1v0.5h-1zM0,-11h3.5v0.5h-3.5zM-8,-10.5h1v0.5h-1zM-0.5,-10.5h4.5v0.5h-4.5zM-8.5,-10h1v0.5h-1zM-0.5,-10h5.5v0.5h-5.5zM-8.5,-9.5h0.5v0.5h-0.5zM-1,-9.5h6.5v0.5h-6.5zM-9,-9h0.5v0.5h-0.5zM-1,-9h4v0.5h-4zM3.5,-9h2.5v0.5h-2.5zM-9.5,-8.5h2v0.5h-2zM-1.5,-8.5h2v1h-2zM1.5,-8.5h3v0.5h-3zM-7.5,-8h1v0.5h-1zM1,-8h2.5v0.5h-2.5zM-7,-7.5h1.5v0.5h-1.5zM-1.5,-7.5h4v0.5h-4zM-6,-7h1.5v0.5h-1.5zM-1.5,-7h2.5v0.5h-2.5zM-5,-6.5h1v0.5h-1zM-3.5,-6.5h0.5v0.5h-0.5zM-1.5,-6.5h2v0.5h-2zM-3,-6h2v0.5h-2z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['thatch', 0.73],
      ],
      d: 'M-3.5,-12h1.5v0.5h-1.5zM-5,-11.5h5v0.5h-5zM-5.5,-11h2.5v0.5h-2.5zM-2.5,-11h2.5v0.5h-2.5zM-7,-10.5h6.5v0.5h-6.5zM-7.5,-10h7v0.5h-7zM-8,-9.5h1v0.5h-1zM-6.5,-9.5h5.5v0.5h-5.5zM-8.5,-9h5v0.5h-5zM-3,-9h2v0.5h-2zM-7,-8.5h0.5v0.5h-0.5zM-6,-8.5h2.5v0.5h-2.5zM-3,-8.5h1.5v1h-1.5zM-6.5,-8h3v0.5h-3zM-5.5,-7.5h4v0.5h-4zM-4.5,-7h3v0.5h-3zM-3,-6.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M3.5,-4h1v0.5h-1zM5,-4h0.5v0.5h-0.5zM6,-3h0.5v1.5h-0.5zM2.5,-2.5h0.5v1h-0.5zM2.5,-1h0.5v1h-0.5zM6,-1h0.5v1.5h-0.5zM3.5,1h1v0.5h-1zM5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M3.5,-7h0.5v0.5h-0.5zM4,-5h1.5v0.5h-1.5zM-6,-4.5h0.5v3.5h-0.5zM-5,-4.5h0.5v0.5h-0.5zM3,-4.5h3.5v0.5h-3.5zM-4.5,-4h0.5v4h-0.5zM2.5,-4h1v0.5h-1zM4.5,-4h0.5v1h-0.5zM5.5,-4h1v0.5h-1zM-3.5,-3.5h0.5v3.5h-0.5zM2.5,-3.5h1.5v0.5h-1.5zM5.5,-3.5h1.5v0.5h-1.5zM2,-3h2v0.5h-2zM4.5,-3h1.5v0.5h-1.5zM6.5,-3h0.5v0.5h-0.5zM2,-2.5h0.5v1h-0.5zM3.5,-2.5h2v0.5h-2zM6.5,-2.5h1v0.5h-1zM5,-2h0.5v0.5h-0.5zM6.5,-2h0.5v0.5h-0.5zM2,-1.5h2v0.5h-2zM5,-1.5h2.5v0.5h-2.5zM-5.5,-1h0.5v0.5h-0.5zM2,-1h0.5v1.5h-0.5zM3.5,-1h0.5v0.5h-0.5zM5,-1h0.5v0.5h-0.5zM6.5,-1h0.5v0.5h-0.5zM3.5,-0.5h2v0.5h-2zM6.5,-0.5h1v0.5h-1zM3,0h1v0.5h-1zM4.5,0h0.5v1.5h-0.5zM5.5,0h0.5v0.5h-0.5zM6.5,0h0.5v0.5h-0.5zM2.5,0.5h1v1h-1zM5.5,0.5h1.5v0.5h-1.5zM6,1h1v0.5h-1zM3,1.5h3v0.5h-3zM3.5,2h2v0.5h-2z',
    },
    { paint: 'anvil', d: 'M4.5,-2h0.5v0.5h-0.5zM4,-1.5h1v1h-1z' },
    {
      paint: 'path',
      d: 'M-8,-0.5h1.5v0.5h-1.5zM-8,0h2.5v0.5h-2.5zM-7,0.5h3v0.5h-3zM-6,1h3v0.5h-3zM-5,1.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 790,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M4,-2h0.5v0.5h-0.5zM-7.5,-1.5h0.5v0.5h-0.5zM-8.5,-1h2.5v0.5h-2.5zM4,-1h0.5v0.5h-0.5zM-6.5,-0.5h1.5v0.5h-1.5zM3.5,-0.5h0.5v0.5h-0.5zM6,-0.5h0.5v0.5h-0.5zM-5.5,0h1.5v0.5h-1.5zM1.5,0h1v0.5h-1zM4.5,0h0.5v0.5h-0.5zM-4,0.5h1v0.5h-1zM0.5,0.5h2v0.5h-2zM4,0.5h0.5v0.5h-0.5zM-3,1h1.5v0.5h-1.5zM-0.5,1h3.5v0.5h-3.5zM-3.5,1.5h6.5v0.5h-6.5zM-3,2h6.5v0.5h-6.5zM-2,2.5h4.5v0.5h-4.5zM-1,3h2v0.5h-2z',
    },
    {
      paint: 'canal',
      d: 'M5.5,-3h0.5v0.5h-0.5zM6,-2.5h0.5v0.5h-0.5zM6.5,-2h0.5v0.5h-0.5zM8,-1.5h0.5v0.5h-0.5zM8,-1h1.5v0.5h-1.5zM8.5,-0.5h1.5v1h-1.5zM5.5,0.5h0.5v0.5h-0.5zM8,0.5h1v0.5h-1zM4.5,1h0.5v0.5h-0.5zM7.5,1h1v0.5h-1zM7,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'waterLight',
      d: 'M4,-3.5h0.5v0.5h-0.5zM4.5,-3h0.5v0.5h-0.5zM6,-2h0.5v0.5h-0.5zM8,-0.5h0.5v1h-0.5zM5.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-6.5,-6h1v0.5h-1zM-6.5,-5.5h2.5v0.5h-2.5zM-6.5,-5h0.5v4h-0.5zM-5,-5h2.5v0.5h-2.5zM-4,-4.5h3v0.5h-3zM-3,-4h2v4.5h-2zM-2.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M2.5,-6.5h1v0.5h-1zM-5.5,-6h0.5v0.5h-0.5zM1.5,-6h2v0.5h-2zM-4,-5.5h0.5v0.5h-0.5zM0,-5.5h3.5v0.5h-3.5zM-6,-5h1v0.5h-1zM-2.5,-5h0.5v0.5h-0.5zM-1,-5h4.5v0.5h-4.5zM-1,-4.5h4v1h-4zM-3.5,-4h0.5v0.5h-0.5zM-1,-3.5h3.5v1.5h-3.5zM-1,-2h3v1.5h-3zM-7,-1.5h0.5v0.5h-0.5zM-6,-1h0.5v0.5h-0.5zM3.5,-1h0.5v0.5h-0.5zM-5,-0.5h0.5v0.5h-0.5zM-1,-0.5h3.5v0.5h-3.5zM-4,0h1v0.5h-1zM-1,0h2.5v0.5h-2.5zM-3,0.5h0.5v0.5h-0.5zM-1,0.5h1.5v0.5h-1.5zM-1.5,1h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-5.5,-4.5h0.5v0.5h-0.5zM-5.5,-4h1v3h-1zM-4,-4h0.5v4h-0.5zM3.5,-4h0.5v0.5h-0.5zM2.5,-2h0.5v0.5h-0.5zM-5,-1h0.5v0.5h-0.5zM7,-1h0.5v0.5h-0.5zM7,0h0.5v0.5h-0.5zM3.5,1h0.5v0.5h-0.5zM6,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-7,-6.5h0.5v5h-0.5zM3.5,-6.5h0.5v1.5h-0.5zM-4.5,-4.5h0.5v0.5h-0.5zM3.5,-2.5h0.5v1h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['thatch', 0.7],
      ],
      d: 'M-3,-10.5h0.5v0.5h-0.5zM0,-10.5h0.5v0.5h-0.5zM3,-9h0.5v0.5h-0.5zM-7.5,-8.5h0.5v0.5h-0.5zM-6.5,-8.5h0.5v0.5h-0.5zM-3.5,-8.5h0.5v1h-0.5zM0.5,-8.5h1v0.5h-1zM5.5,-8.5h1v0.5h-1zM-10,-8h1v0.5h-1zM-8,-8h0.5v0.5h-0.5zM0.5,-8h0.5v0.5h-0.5zM4,-8h2v0.5h-2zM-9.5,-7.5h2v0.5h-2zM3,-7.5h2v0.5h-2zM-8.5,-7h2v0.5h-2zM1.5,-7h2v0.5h-2zM-6.5,-6.5h1.5v0.5h-1.5zM-4,-6.5h0.5v0.5h-0.5zM0.5,-6.5h2v0.5h-2zM-5,-6h1.5v0.5h-1.5zM-0.5,-6h2v0.5h-2zM-3.5,-5.5h3.5v0.5h-3.5zM-2,-5h1v0.5h-1zM4.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'thatch',
      d: 'M-4.5,-11.5h1v0.5h-1zM-2.5,-11.5h3.5v0.5h-3.5zM-7,-11h2.5v0.5h-2.5zM0,-11h3v0.5h-3zM-8,-10.5h1.5v0.5h-1.5zM0.5,-10.5h4v0.5h-4zM-9,-10h1.5v0.5h-1.5zM-0.5,-10h6v0.5h-6zM-9.5,-9.5h1v0.5h-1zM-1,-9.5h7.5v0.5h-7.5zM-10,-9h0.5v0.5h-0.5zM-1,-9h4v0.5h-4zM3.5,-9h3v0.5h-3zM-10,-8.5h1.5v0.5h-1.5zM-1.5,-8.5h2v1h-2zM1.5,-8.5h4v0.5h-4zM-9,-8h1v0.5h-1zM-7.5,-8h0.5v0.5h-0.5zM1,-8h3v0.5h-3zM-7.5,-7.5h1.5v0.5h-1.5zM-1.5,-7.5h4.5v0.5h-4.5zM-6.5,-7h2v0.5h-2zM-1.5,-7h3v0.5h-3zM-5,-6.5h1v0.5h-1zM-1.5,-6.5h2v0.5h-2zM-3.5,-6h3v0.5h-3z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['thatch', 0.73],
      ],
      d: 'M-3.5,-11.5h1v0.5h-1zM-4.5,-11h4.5v0.5h-4.5zM-6.5,-10.5h3.5v0.5h-3.5zM-2.5,-10.5h2.5v0.5h-2.5zM-7.5,-10h7v0.5h-7zM-8.5,-9.5h7.5v0.5h-7.5zM-9.5,-9h8.5v0.5h-8.5zM-8.5,-8.5h1v0.5h-1zM-7,-8.5h0.5v0.5h-0.5zM-6,-8.5h2.5v0.5h-2.5zM-3,-8.5h1.5v1h-1.5zM-7,-8h3.5v0.5h-3.5zM-6,-7.5h4.5v0.5h-4.5zM-4.5,-7h3v0.5h-3zM-3.5,-6.5h2v0.5h-2z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M4,-4.5h1v0.5h-1zM5.5,-4.5h0.5v0.5h-0.5zM4,-4h0.5v0.5h-0.5zM5.5,-4h1v0.5h-1zM3,-3h0.5v1.5h-0.5zM6.5,-3h0.5v0.5h-0.5zM6.5,-2.5h1v0.5h-1zM7,-2h0.5v0.5h-0.5zM3,-0.5h0.5v1h-0.5zM7,-0.5h0.5v0.5h-0.5zM6.5,0h0.5v0.5h-0.5zM4,1h0.5v0.5h-0.5zM6,1h0.5v0.5h-0.5zM4,1.5h1v0.5h-1zM5.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M3.5,-7h0.5v0.5h-0.5zM4,-5.5h2v0.5h-2zM3.5,-5h3v0.5h-3zM-6,-4.5h0.5v3.5h-0.5zM-5,-4.5h0.5v0.5h-0.5zM3,-4.5h1v0.5h-1zM5,-4.5h0.5v0.5h-0.5zM6,-4.5h1v0.5h-1zM-4.5,-4h0.5v4h-0.5zM3,-4h0.5v0.5h-0.5zM4.5,-4h1v1h-1zM6.5,-4h1v0.5h-1zM-3.5,-3.5h0.5v3.5h-0.5zM2.5,-3.5h1.5v0.5h-1.5zM6,-3.5h2v0.5h-2zM2.5,-3h0.5v1h-0.5zM3.5,-3h1v0.5h-1zM5,-3h0.5v0.5h-0.5zM6,-3h0.5v0.5h-0.5zM7,-3h1v0.5h-1zM4,-2.5h2v0.5h-2zM7.5,-2.5h0.5v1h-0.5zM2,-2h0.5v0.5h-0.5zM5.5,-2h0.5v0.5h-0.5zM2,-1.5h2.5v0.5h-2.5zM5.5,-1.5h2.5v0.5h-2.5zM-5.5,-1h0.5v0.5h-0.5zM2,-1h1.5v0.5h-1.5zM5.5,-1h1.5v0.5h-1.5zM7.5,-1h0.5v1.5h-0.5zM2.5,-0.5h0.5v1h-0.5zM4,-0.5h2v0.5h-2zM6.5,-0.5h0.5v0.5h-0.5zM3.5,0h1v0.5h-1zM5,0h1.5v0.5h-1.5zM2.5,0.5h1.5v0.5h-1.5zM4.5,0.5h1v0.5h-1zM6,0.5h2v0.5h-2zM3,1h0.5v0.5h-0.5zM5,1h0.5v1h-0.5zM6.5,1h1v0.5h-1zM3,1.5h1v0.5h-1zM6.5,1.5h0.5v0.5h-0.5zM3.5,2h3.5v0.5h-3.5zM4,2.5h2.5v0.5h-2.5z',
    },
    { paint: 'anvil', d: 'M5,-2h0.5v0.5h-0.5zM4.5,-1.5h1v1h-1z' },
    {
      paint: 'path',
      d: 'M-8,-0.5h1.5v0.5h-1.5zM-8,0h2.5v0.5h-2.5zM-7,0.5h3v0.5h-3zM-6,1h3v0.5h-3zM-5,1.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 806,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M-7.5,-1.5h0.5v0.5h-0.5zM-8.5,-1h2.5v0.5h-2.5zM5,-1h0.5v0.5h-0.5zM-6.5,-0.5h1.5v0.5h-1.5zM3,-0.5h0.5v0.5h-0.5zM-5.5,0h1.5v0.5h-1.5zM1.5,0h0.5v0.5h-0.5zM3.5,0h0.5v1h-0.5zM4.5,0h0.5v0.5h-0.5zM-4,0.5h1v0.5h-1zM0.5,0.5h2v0.5h-2zM-3,1h1.5v0.5h-1.5zM-0.5,1h3v0.5h-3zM-3.5,1.5h6.5v0.5h-6.5zM-3,2h6.5v0.5h-6.5zM-2,2.5h4.5v0.5h-4.5zM-1,3h2v0.5h-2z',
    },
    {
      paint: 'canal',
      d: 'M7,-2h1v0.5h-1zM7.5,-1.5h1v0.5h-1zM8,-1h1.5v0.5h-1.5zM8.5,-0.5h1.5v1h-1.5zM7.5,0.5h1.5v0.5h-1.5zM7,1h1.5v0.5h-1.5zM6,1.5h1.5v0.5h-1.5zM3.5,2h3.5v0.5h-3.5zM4.5,2.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'waterLight',
      d: 'M4.5,-3h0.5v0.5h-0.5zM7,-1h1v0.5h-1zM7.5,-0.5h1v0.5h-1zM7,0h1.5v0.5h-1.5zM6.5,0.5h1v0.5h-1zM6,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['wall', 0.73],
      ],
      d: 'M-6.5,-6h1.5v0.5h-1.5zM-6.5,-5.5h2.5v0.5h-2.5zM-6.5,-5h0.5v4h-0.5zM-5,-5h2.5v0.5h-2.5zM-4,-4.5h3v0.5h-3zM-3,-4h2v4.5h-2zM-2.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['wall', 0.7],
      ],
      d: 'M3,-7h0.5v0.5h-0.5zM-6.5,-6.5h0.5v0.5h-0.5zM2,-6.5h1.5v0.5h-1.5zM1,-6h2.5v0.5h-2.5zM-4,-5.5h0.5v0.5h-0.5zM0,-5.5h3.5v0.5h-3.5zM-6,-5h1v0.5h-1zM-2.5,-5h0.5v0.5h-0.5zM-1,-5h4.5v1h-4.5zM-3.5,-4h0.5v0.5h-0.5zM-1,-4h4v0.5h-4zM-1,-3.5h3.5v0.5h-3.5zM-1,-3h3v3h-3zM3,-2h0.5v0.5h-0.5zM-7,-1.5h0.5v0.5h-0.5zM-6,-1h0.5v0.5h-0.5zM3,-1h0.5v0.5h-0.5zM-5,-0.5h0.5v0.5h-0.5zM-4,0h1v0.5h-1zM-1,0h2.5v0.5h-2.5zM-3,0.5h0.5v0.5h-0.5zM-1,0.5h1.5v0.5h-1.5zM-1.5,1h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-5.5,-4.5h0.5v0.5h-0.5zM-5.5,-4h1v3h-1zM-4,-4h0.5v4h-0.5zM4.5,-4h0.5v0.5h-0.5zM3.5,-3.5h0.5v0.5h-0.5zM6,-2h0.5v0.5h-0.5zM-5,-1h0.5v0.5h-0.5zM2.5,-1h0.5v0.5h-0.5zM5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-7,-6.5h0.5v5h-0.5zM3.5,-6.5h0.5v1.5h-0.5zM3.5,-5h1v0.5h-1zM-4.5,-4.5h0.5v0.5h-0.5zM3.5,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['thatch', 0.7],
      ],
      d: 'M-3,-12h0.5v0.5h-0.5zM0,-12h0.5v0.5h-0.5zM-6.5,-11h0.5v0.5h-0.5zM-7,-10h0.5v0.5h-0.5zM-3.5,-9.5h0.5v2h-0.5zM-9,-9h1v0.5h-1zM-7.5,-9h0.5v1h-0.5zM0.5,-9h0.5v0.5h-0.5zM3,-9h0.5v0.5h-0.5zM-6.5,-8.5h0.5v0.5h-0.5zM0.5,-8.5h1v0.5h-1zM4.5,-8.5h1v0.5h-1zM-9,-8h1.5v0.5h-1.5zM0.5,-8h0.5v0.5h-0.5zM3.5,-8h1.5v0.5h-1.5zM-8.5,-7.5h1.5v0.5h-1.5zM2,-7.5h2v0.5h-2zM-7.5,-7h1.5v0.5h-1.5zM1,-7h2v0.5h-2zM-6,-6.5h1v0.5h-1zM-4,-6.5h0.5v0.5h-0.5zM0,-6.5h2v0.5h-2zM-5,-6h2v0.5h-2zM-1,-6h2v0.5h-2zM-3.5,-5.5h3.5v0.5h-3.5zM-2,-5h1v0.5h-1zM4.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'thatch',
      d: 'M-2.5,-13h2.5v0.5h-2.5zM-5.5,-12.5h1v0.5h-1zM0,-12.5h1.5v0.5h-1.5zM-6.5,-12h1v0.5h-1zM0.5,-12h2v0.5h-2zM-7,-11.5h1v0.5h-1zM0,-11.5h3v0.5h-3zM-7.5,-11h0.5v0.5h-0.5zM-0.5,-11h4.5v0.5h-4.5zM-8,-10.5h0.5v0.5h-0.5zM-0.5,-10.5h5v0.5h-5zM-8.5,-10h0.5v1h-0.5zM-1,-10h6v0.5h-6zM-1,-9.5h6.5v0.5h-6.5zM-1,-9h1.5v0.5h-1.5zM1,-9h2v0.5h-2zM3.5,-9h2v0.5h-2zM-9,-8.5h1.5v0.5h-1.5zM-1.5,-8.5h2v1h-2zM1.5,-8.5h3v0.5h-3zM-7.5,-8h1v0.5h-1zM1,-8h2.5v0.5h-2.5zM-7,-7.5h1.5v0.5h-1.5zM-1.5,-7.5h3.5v0.5h-3.5zM-6,-7h1.5v0.5h-1.5zM-1.5,-7h2.5v0.5h-2.5zM-5,-6.5h1v0.5h-1zM-3.5,-6.5h0.5v0.5h-0.5zM-1.5,-6.5h1.5v0.5h-1.5zM-3,-6h2v0.5h-2z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['thatch', 0.73],
      ],
      d: 'M-3.5,-13h1v0.5h-1zM-4.5,-12.5h4.5v0.5h-4.5zM-5.5,-12h2.5v0.5h-2.5zM-2.5,-12h2.5v0.5h-2.5zM-6,-11.5h6v0.5h-6zM-7,-11h0.5v0.5h-0.5zM-6,-11h5.5v0.5h-5.5zM-7.5,-10.5h7v0.5h-7zM-8,-10h1v0.5h-1zM-6.5,-10h5.5v0.5h-5.5zM-8,-9.5h4.5v0.5h-4.5zM-3,-9.5h2v1h-2zM-8,-9h0.5v0.5h-0.5zM-7,-9h3.5v0.5h-3.5zM-7,-8.5h0.5v0.5h-0.5zM-6,-8.5h2.5v0.5h-2.5zM-3,-8.5h1.5v1h-1.5zM-6.5,-8h3v0.5h-3zM-5.5,-7.5h4v0.5h-4zM-4.5,-7h3v0.5h-3zM-3,-6.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M3.5,-4h0.5v0.5h-0.5zM5,-3.5h0.5v0.5h-0.5zM2.5,-2.5h0.5v1h-0.5zM2.5,-0.5h0.5v0.5h-0.5zM5.5,-0.5h0.5v0.5h-0.5zM5,0.5h0.5v0.5h-0.5zM3.5,1h0.5v0.5h-0.5zM4.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M3.5,-7h0.5v0.5h-0.5zM-6,-4.5h0.5v3.5h-0.5zM-5,-4.5h0.5v0.5h-0.5zM3.5,-4.5h2v0.5h-2zM-4.5,-4h0.5v4h-0.5zM3,-4h0.5v0.5h-0.5zM4,-4h0.5v0.5h-0.5zM5,-4h1v0.5h-1zM-3.5,-3.5h0.5v3.5h-0.5zM2.5,-3.5h1v0.5h-1zM4,-3.5h1v0.5h-1zM5.5,-3.5h1v0.5h-1zM2,-3h1.5v0.5h-1.5zM4,-3h0.5v0.5h-0.5zM5,-3h2v0.5h-2zM2,-2.5h0.5v1h-0.5zM3,-2.5h4v0.5h-4zM3.5,-2h0.5v0.5h-0.5zM5,-2h1v0.5h-1zM6.5,-2h0.5v0.5h-0.5zM2,-1.5h2v0.5h-2zM5,-1.5h2.5v0.5h-2.5zM-5.5,-1h0.5v0.5h-0.5zM2,-1h0.5v1h-0.5zM3.5,-1h0.5v0.5h-0.5zM5.5,-1h1.5v0.5h-1.5zM3.5,-0.5h2v0.5h-2zM6,-0.5h1.5v0.5h-1.5zM2,0h1.5v0.5h-1.5zM4,0h0.5v0.5h-0.5zM5,0h2v0.5h-2zM2.5,0.5h1v1h-1zM4,0.5h1v0.5h-1zM5.5,0.5h1v0.5h-1zM4,1h0.5v0.5h-0.5zM5.5,1h0.5v0.5h-0.5zM6.5,1h0.5v0.5h-0.5zM3,1.5h3v0.5h-3z',
    },
    { paint: 'anvil', d: 'M4,-2h0.5v0.5h-0.5zM4,-1.5h1v1h-1z' },
    {
      paint: 'path',
      d: 'M-8,-0.5h1.5v0.5h-1.5zM-8,0h2.5v0.5h-2.5zM-7,0.5h3v0.5h-3zM-6,1h3v0.5h-3zM-5,1.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 811,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
